/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Max_PrefixInputs */

const en_admin_resource_form_max_prefix = /** @type {(inputs: Admin_Resource_Form_Max_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`max.`)
};

const de_admin_resource_form_max_prefix = /** @type {(inputs: Admin_Resource_Form_Max_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`max.`)
};

const es_admin_resource_form_max_prefix = /** @type {(inputs: Admin_Resource_Form_Max_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`máx.`)
};

const fr_admin_resource_form_max_prefix = /** @type {(inputs: Admin_Resource_Form_Max_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`max.`)
};

const nl_admin_resource_form_max_prefix = /** @type {(inputs: Admin_Resource_Form_Max_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`max.`)
};

/** @type {(inputs: Admin_Resource_Form_Max_PrefixInputs) => LocalizedString} */
const it_admin_resource_form_max_prefix = en_admin_resource_form_max_prefix;

/** @type {(inputs: Admin_Resource_Form_Max_PrefixInputs) => LocalizedString} */
const pt_br2_admin_resource_form_max_prefix = en_admin_resource_form_max_prefix;

/** @type {(inputs: Admin_Resource_Form_Max_PrefixInputs) => LocalizedString} */
const pl_admin_resource_form_max_prefix = en_admin_resource_form_max_prefix;

/** @type {(inputs: Admin_Resource_Form_Max_PrefixInputs) => LocalizedString} */
const hu_admin_resource_form_max_prefix = en_admin_resource_form_max_prefix;

/** @type {(inputs: Admin_Resource_Form_Max_PrefixInputs) => LocalizedString} */
const ro_admin_resource_form_max_prefix = en_admin_resource_form_max_prefix;

/**
* | output |
* | --- |
* | "max." |
*
* @param {Admin_Resource_Form_Max_PrefixInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_max_prefix = /** @type {((inputs?: Admin_Resource_Form_Max_PrefixInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Max_PrefixInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_max_prefix(inputs)
	if (locale === "de") return de_admin_resource_form_max_prefix(inputs)
	if (locale === "es") return es_admin_resource_form_max_prefix(inputs)
	if (locale === "fr") return fr_admin_resource_form_max_prefix(inputs)
	if (locale === "nl") return nl_admin_resource_form_max_prefix(inputs)
	if (locale === "it") return it_admin_resource_form_max_prefix(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_max_prefix(inputs)
	if (locale === "pl") return pl_admin_resource_form_max_prefix(inputs)
	if (locale === "hu") return hu_admin_resource_form_max_prefix(inputs)
	return ro_admin_resource_form_max_prefix(inputs)
});
export { admin_resource_form_max_prefix as "admin.resource_form.max_prefix" }